import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

/**
 * Programador de tareas de Monere (solo equipo Monere): estado de las tareas
 * periódicas y ejecución manual.
 */
const useSchedulerService = () => {
    const { doGet, doPost } = useFetch();

    const BASE_PATH = 'scheduler';

    const [fetchingJobs, setFetchingJobs] = useState(false);
    const [fetchingRunJob, setFetchingRunJob] = useState(false);

    const getScheduledJobs = (events: ServiceEvents = {}) => {
        doGet({ ...events, url: buildEndpoint(`${BASE_PATH}/jobs`), setFetching: setFetchingJobs });
    };

    const runScheduledJob = (name: string, events: ServiceEvents = {}) => {
        doPost({ ...events, url: buildEndpoint(`${BASE_PATH}/jobs/${encodeURIComponent(name)}/run`), setFetching: setFetchingRunJob });
    };

    return { fetchingJobs, fetchingRunJob, getScheduledJobs, runScheduledJob };
};

export default useSchedulerService;
